(function () {
  'use strict';

  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
      'ngTable'
    		, 'chart.js'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('ReportsFinancialConfferenceController', reports);

  reports.$inject = ['$scope', '$http', 'NotificationService', 'LangService'];

  function reports ($scope, $http, NotificationService, LangService) {
    var vm = this;
    	$scope.vm = vm;

    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY'),
      status: 1
    };

    LangService
      .getPageLabels({ 'page': 'menu.reports.financialConfference' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
      });

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

    vm.generate = function (downloadReport) {
      $http.get(apiUrl + '/reports/financial', {
        params: {
          filters: vm.filters,
          downloadReport: true,
          reportType: 'FinancialConfference'
        }
      })
        .then(function ({ data, status, headers, config }) {
          if (data.error) {
            NotificationService.errorHandler(data, data.error);
            return;
          }

          var filename = headers('Mktzap-Filename') || 'financial' + '.csv';

          var anchor = angular.element('<a/>');
          anchor.css({ display: 'none' });
          angular.element(document.body).append(anchor);

          var blob = new Blob([data], { type: 'text/csv' });
          var csvUrl = URL.createObjectURL(blob);

          anchor.attr({
            href: csvUrl,
            target: '_self',
            download: filename
          })[0].click();

          anchor.remove();
          URL.revokeObjectURL(csvUrl);
        }, function ({ data, status, headers, config }) {
          NotificationService.errorHandler(data, vm.labels.errorReport);

          $http.get(apiUrl + '/reports/financial', {
            params: {
              filters: vm.filters,
              downloadReport: true,
              reportType: 'FinancialConfference',
              sendByEmail: true
            }
          })
            .then(function ({ data, status, headers, config }) {
              if (data.success) {
                NotificationService.warningHandler(null, vm.labels.alertProcessMail);
              }
            }, function ({ data, status, headers, config }) {
              NotificationService.errorHandler(data, vm.labels.errorReport);
            })
        })
    }
  }
})();
